import { UserRole } from '@/lib/enums';

/**
 * The login page a signed-out user should land on.
 *
 * Employees and kitchen staff authenticate with an employee ID plus an organization
 * on `/auth/employee-login`; everyone else uses the email form on `/auth/login`.
 *
 * A user with no roles falls through to `/auth/login`, which is where the proxy also
 * sends unauthenticated `/app` requests. Deliberately not `getPrimaryRole()`: that
 * helper defaults an empty role list to `employee`, which would strand a role-less
 * user on a form they cannot fill in.
 */
export function loginRouteForRoles(roles: readonly string[] | null | undefined): string {
  const usesEmployeeLogin = roles?.includes(UserRole.employee) || roles?.includes(UserRole.kitchen);
  return usesEmployeeLogin ? '/auth/employee-login' : '/auth/login';
}
